<template>
  <div>
    <template v-if="alternativeLabel">
      <label-required-field v-if="required" :label="label" @click="focus" />
      <label v-else @click="focus"> {{ label }} </label>
    </template>
    <v-select
      ref="input"
      outlined
      dense
      :autofocus="autofocus"
      :chips="chips"
      :disabled="disabled"
      :hide-details="hideDetails"
      :hint="hint"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :label="cLabel"
      :messages="messages"
      :multiple="multiple"
      :persistent-hint="persistentHint"
      :placeholder="cPlaceholder"
      :required="required"
      :return-object="returnObject"
      :value="value"
      @change="$emit('change', $event)"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import LabelRequiredField from "./LabelRequiredField";

export default {
  name: "VSelectDefault",

  components: { LabelRequiredField },

  props: {
    alternativeLabel: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    chips: { type: Boolean, default: false },
    disabled: { type: Boolean, defualt: false },
    hideDetails: { type: [String, Boolean], default: "auto" },
    hint: { Type: String, required: false },
    items: { type: Array, required: true },
    itemText: { type: [String, Function], default: "name" },
    itemValue: { type: String, default: "id" },
    label: { type: String, required: true },
    messages: { type: [String, Array], required: false },
    multiple: { type: Boolean, default: false },
    persistentHint: { type: Boolean, default: false },
    placeholder: { type: String, default: undefined },
    required: { type: Boolean, default: false },
    returnObject: { type: Boolean, default: false },
    value: { type: [String, Number, Object, Array], default: "" },
  },

  computed: {
    cLabel() {
      return this.alternativeLabel ? undefined : this.label;
    },

    cPlaceholder() {
      if (this.placeholder) return this.placeholder;
      return this.alternativeLabel ? this.label : undefined;
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style>
</style>